import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
} from "@chakra-ui/react";
import { cn } from "utils/helpers";

type ModalNewProps = {
	children: React.ReactNode;
	isOpen: boolean;
	onClose: () => void;
	headerContent?: React.ReactNode | string;
	contentClassName?: string;
	bodyClassName?: string;
	padding?: boolean;
	width?: string;
	maxWidth?: string;
};
export const ModalNew = ({
	children,
	isOpen,
	onClose,
	headerContent,
	contentClassName,
	bodyClassName,
	padding = true,
	width = "1130px",
	maxWidth = "90vw",
}: ModalNewProps) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size="xl"
			scrollBehavior="inside"
			isCentered
		>
			<ModalOverlay
				bg="blackAlpha.300"
				backdropFilter="blur(5px)"
			/>
			<ModalContent
				my="auto"
				borderRadius={padding ? "lg" : null}
				boxShadow="xl"
				display="flex"
				flexDirection="column"
				width={width}
				maxWidth={maxWidth}
				className={cn("w-[1130px] max-w-[90vw]", contentClassName)}
			>
				{headerContent ? (
					<ModalHeader
						tabIndex={-1}
						borderBottomWidth={headerContent ? "1px" : 0}
						py={headerContent ? "22px" : 0}
						className="border-quarternary"
					>
						{typeof headerContent === "string" ? (
							<div className="flex items-center justify-between pr-12">
								<h2 className="font-heading text-[36px] font-normal text-royal-blue">
									{headerContent}
								</h2>
							</div>
						) : (
							<>{headerContent}</>
						)}
						<ModalCloseButton size="lg" />
					</ModalHeader>
				) : null}

				<ModalBody
					py={padding ? 10 : 0}
					px={padding ? 6 : 0}
					className={cn("max-h-[90vh] px-10 py-6", bodyClassName)}
					onWheel={(e) => {
						// force scroll
						// const target = e.currentTarget;
						// target.scrollTop += e.deltaY;
					}}
				>
					{!headerContent ? (
						<ModalCloseButton
							size="lg"
							className="z-[999]"
						/>
					) : null}
					{children}
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
